import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=90549a78&scoped=true&"
import script from "./ServicesPage.vue?vue&type=script&lang=js&"
export * from "./ServicesPage.vue?vue&type=script&lang=js&"
import style0 from "./ServicesPage.vue?vue&type=style&index=0&id=90549a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90549a78",
  null
  
)

export default component.exports